import React, { useState, useEffect } from "react";
import RadioGroup from "../../atoms/RadioGroup";
import { Skeleton } from "antd";
import { getAllRegistries } from "../../../utils/API/getAllRegistries";
import { getRegistryImage } from "../../../utils/helper/getRegistryImage";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";

const Registries = ({ selectedRegistry, onCheckRegistry }) => {
  const dispatch = useDispatch();
  const [registries, setRegistries] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRegistries = async () => {
      setLoading(true);
      try {
        const registriesData = await getAllRegistries(dispatch);
        setRegistries(registriesData);
      } catch (error) {
        toast.error("Error fetching registries. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchRegistries();
  }, []);

  return (
    <div className="flex flex-wrap items-center ml-3 mb-4">
      {loading ? (
        <div className="flex flex-col gap-y-4 w-full">
          <Skeleton.Button block={true} active={true} />
          <Skeleton.Button block={true} active={true} />
        </div>
      ) : error ? (
        <div className="text-red-600">{error}</div>
      ) : (
        <RadioGroup
          options={registries.map((registry) => ({
            label: getRegistryImage(registry.registryName) ? (
              <div
                className="w-16 h-8 bg-cover"
                style={{
                  background: `url(${getRegistryImage(registry.registryName)})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPosition: "center"
                }}
              ></div>
            ) : (
              <div className="text-xs font-normal text-blue-800">
                {registry.registryName}
              </div>
            ),
            value: registry._id
          }))}
          onChange={onCheckRegistry}
          value={selectedRegistry}
        />
      )}
    </div>
  );
};

export default Registries;
